import PhenotypeCarousel from "./PhenotypeCarousel";

export default PhenotypeCarousel;
